<div class="btn-container">
    <button type= "button" class = "btn btn-primary mr-3 shadow-none" (click)="getDTCData('currentDTC')" [ngStyle]="{'background-color': highlightCurrent ? '#2f5b92' : (!highlightCurrent ? '#003478' : null) }">{{'CURRENT DTC DATA'|translate}}</button>
    <button type= "button" class = "btn btn-primary mr-3 shadow-none" (click)="getDTCData('historyDTC')" [ngStyle]="{'background-color': highlightHistory ? '#2f5b92' : (!highlightHistory ? '#003478' : null) }">{{'HISTORICAL DTC DATA'|translate}}</button>
    <label [ngStyle]="{'visibility': highlightHistory ? 'visible' : 'hidden'}">{{'Filter DTC Data'|translate}} ({{'Days'| translate}}): &nbsp;</label> 
    <select name="filterData" [ngStyle]="{'visibility': highlightHistory ? 'visible' : 'hidden'}" id="filterData" #setDays
                                            (change)="filterDTCData(setDays.value)">
                                            <option value="30" selected="selected" class="filter">30</option>
                                            <option value="90" class="filter">90</option>&nbsp;
                                            <option value="180" class="filter" disabled>180</option>&nbsp;
                                            <option value="270" class="filter" disabled>270</option>&nbsp;
                                            <option value="365" class="filter" disabled>365</option>&nbsp;
                                            <option value="0" class="filter" disabled>{{'All'|translate}}</option>
                                        </select>
</div>
<div class='DTC-List-Container'>
    <table border="1" cellpadding="0" cellspacing="0" width="95%" class="DTCTable table-bordered">
        <thead style="font-size: 10pt;">
            <style>
                tr:nth-child(odd) {
                background-color: #f2f2f2;
            }
            table {
                    border-collapse: separate;
                     border-spacing: 0 15px;
                  }
            </style>
            <tr>
                <th style="background-color:#003478;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:center;">
                {{'Date Requested'|translate}}</th>
                <th style="background-color:#003478;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:center;">
                {{'Module'|translate}}</th>
                <th style="background-color:#003478;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:center;">
                {{'DTC'|translate}}</th>
                <th style="background-color:#003478;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:center;">
                {{'Description'|translate}}</th>
                <th style="background-color:#003478;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:center;">
                {{'Failure Type'|translate}}</th>
                <th style="background-color:#003478;color:#FFFFFF;padding-top:2px;font-weight:900;text-align:center;">
                {{'Status Byte'|translate}}</th>
            </tr>
        </thead>
            <tbody *ngIf="DTCData?.length && !showloader" class="table-bordered">
                <tr *ngFor="let list of DTCData">
                    <td>{{list.timestamp | date: 'dd-MM-yyyy hh:mm:ss'}}</td>
                    <td>{{list.module}}</td>
                    <td>{{list.dtc}}</td>
                    <td>{{list.description}}</td>
                    <td>{{list.failureType}}</td>
                    <td>{{list.statusType}}</td>
                </tr>
            </tbody>
            <tbody *ngIf="!DTCData?.length && !showloader">
                <tr colspan="6">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{'No Data Available'|translate}}</td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
    </table>
</div>
<div *ngIf=showloader class="loader2">
    <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="100" height="100">
  </div>
